import { useState } from "react"
import { Gift, HandCoinsIcon } from "lucide-react"
import type { IAccountPayableBill } from "@apis/accounts/types"
import { formatDate } from "@utils/formatters"
import { RewardCheckItemDetail } from "./RewardCheckItemDetail"

type TRewardCheckItemProps = { payable_bill: IAccountPayableBill }

export const RewardCheckItem = ({
  payable_bill: payable_bill,
}: TRewardCheckItemProps) => {
  const [open, setOpen] = useState(false)

  const isReward = !!payable_bill.reward
  const label = isReward ? "Reward" : "Refund"

  const detailText = isReward
    ? payable_bill.reward!.reward_description
    : payable_bill.case!.case_type_category.category_name

  return (
    <div className="tw:mb-2 tw:rounded tw:border tw:border-gray-200">
      <button
        className="tw:flex tw:w-full tw:items-center tw:justify-between tw:bg-gray-50 tw:p-4"
        onClick={() => setOpen((open) => !open)}
      >
        <div className="tw:flex tw:items-center tw:gap-4">
          <span className="tw:rounded tw:bg-green-600 tw:px-2 tw:py-1 tw:text-white">
            ${payable_bill.amount}
          </span>
          {isReward ? (
            <Gift className="tw:h-5 tw:w-5" />
          ) : (
            <HandCoinsIcon className="tw:h-5 tw:w-5" />
          )}
          <span className="tw:font-medium">{`${label} - ${detailText}`}</span>
        </div>
        <span className="tw:text-gray-500">
          {payable_bill.check_status || "PENDING APPROVAL"} (
          {formatDate(payable_bill.created_at, "M/dd/yy")})
        </span>
      </button>

      {open && <RewardCheckItemDetail payable_bill={payable_bill} />}
    </div>
  )
}
